// Campaign unlock rules. Shared by the Schnellspiel atlas (MapSelectScene) and
// the Kampagne world map (CampaignScene) so both screens can never disagree
// about which level is open.

import { CAMPAIGN_MAPS, type MapDef } from "./maps";
import type { save } from "../systems/Save";

type SaveData = ReturnType<typeof save.load>;

/** A map unlocks once the previous map has been cleared on Squire at least
 *  once (1+ star). The first map in the campaign is always open. */
export function isMapLocked(map: MapDef, data: SaveData): boolean {
  const idx = CAMPAIGN_MAPS.indexOf(map);
  if (idx <= 0) return false;
  const prev = CAMPAIGN_MAPS[idx - 1];
  return (data.campaign.cleared[prev.key] ?? 0) < 1;
}

/** Short human-readable unlock requirement for a locked map. */
export function lockRequirement(map: MapDef): string {
  const idx = CAMPAIGN_MAPS.indexOf(map);
  const prev = CAMPAIGN_MAPS[idx - 1];
  return prev ? `Beat ${prev.name} on Squire` : "";
}

/** Index of the furthest map the player may currently enter. Drives how far
 *  the campaign route is drawn as "travelled". */
export function furthestUnlockedIndex(data: SaveData): number {
  let last = 0;
  for (let i = 0; i < CAMPAIGN_MAPS.length; i++) {
    if (!isMapLocked(CAMPAIGN_MAPS[i], data)) last = i;
  }
  return last;
}
